import { render, staticRenderFns } from "./NewIcon.vue?vue&type=template&id=7fffc656&scoped=true"
import script from "./NewIcon.vue?vue&type=script&lang=js"
export * from "./NewIcon.vue?vue&type=script&lang=js"
import style0 from "./NewIcon.vue?vue&type=style&index=0&id=7fffc656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fffc656",
  null
  
)

export default component.exports